import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Core from '../api/core';
import { useAppDispatch } from '../infra/hooks';
import { permissionService } from '../api/permissionService';
export function usePermission(name: string): boolean {
  const [canShow, setCanShow] = useState<boolean>(false);
  const adminId = useSelector((state: any) => state?.adminIdSlice?.adminId);

  useEffect(() => {
    const hasPermission = async () => {
      const response = await permissionService.userHasPermission(adminId, name);
      setCanShow(response.data);
    };

    hasPermission();
  }, []);

  return canShow;
}
